<template>
	<div class="ploutos-wrapper">
		<div class="overlay"></div>

		<el-card class="ploutos-card" shadow="always">
			<div class="header">
				<h1 class="brand">PLOUTOS</h1>
			</div>

			<el-form ref="form" :model="model" :rules="rules" label-position="top" @submit.native.prevent="submit" class="form-space">
				<!-- USERNAME -->
				<el-form-item label="Username" prop="username">
					<el-input v-model="model.username" size="large" placeholder="Enter your username" :prefix-icon="User" class="input-dark" autocomplete="username" />
				</el-form-item>

				<!-- PASSWORD -->
				<el-form-item label="Password" prop="password">
					<el-input
						v-model="model.password"
						size="large"
						type="password"
						show-password
						placeholder="Enter your password"
						:prefix-icon="Lock"
						class="input-dark"
						autocomplete="current-password"
					/>
				</el-form-item>

				<!-- BOTÓN LOGIN -->
				<el-button size="large" type="primary" native-type="submit" class="btn-primary full-width-btn" round> Inicia sesion </el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script setup>
	import { reactive, ref, computed } from 'vue';
	import { ElLoading, ElMessage } from 'element-plus';
	import { User, Lock } from '@element-plus/icons-vue';


	// modelo
	const model = reactive({
		username: '',
		password: '',
	});

	// reglas
	const rules = reactive({
		username: [{ required: true, message: 'Ingrese usuario', trigger: 'blur' }],
		password: [{ required: true, message: 'Ingrese contraseña', trigger: 'blur' }],
		// sucursal y caja se agregan dinámicamente
	});

	const form = ref(null);


	// submit
	const submit = () => {
		
		form.value.validate(async (valid) => {
			if (!valid) {
				ElMessage({ message: 'Verifique los datos', type: 'error' });
				return;
			}

			const loading = ElLoading.service();

			try {
				const res = await fetch('/login', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(model),
				});

				if (res.status === 200) {
					await res.json();
					window.location = '/';
				} else {
					const json = await res.json();
					ElMessage({ message: json.error, type: 'error' });
				}
			} catch {
				ElMessage({ message: 'Error de red', type: 'error' });
			} finally {
				loading.close();
			}
		});
	};
</script>

<style scoped>
	@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700&display=swap');

	/* Fondo estilo PLOUTOS */
	.ploutos-wrapper {
		position: relative;
		min-height: 100vh;
		display: grid;
		place-items: center;
		padding: 1rem;
		overflow: hidden;
		font-family: 'Inter', sans-serif;
		background-image: url('https://images.unsplash.com/photo-1541701494587-cb58502866ab?q=80&w=2070&auto=format&fit=crop');
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
	}

	.overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(15, 23, 42, 0.65) 100%);
		backdrop-filter: blur(4px);
	}

	/* Tarjeta transparente estilo vidrio */
	.ploutos-card {
		width: 100%;
		max-width: 400px;
		z-index: 10;
		border-radius: 24px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		background: rgba(255, 255, 255, 0.05);
		backdrop-filter: blur(20px);
		-webkit-backdrop-filter: blur(20px);
		box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
		padding: 2.5rem 2rem;
	}

	/* Eliminar bordes y sombras por defecto de el-card */
	.ploutos-card :deep(.el-card__body) {
		padding: 0;
	}

	/* Marca */
	.brand {
		font-family: 'Cinzel', serif;
		font-size: 2.5rem;
		color: #ffffff;
		font-weight: 700;
		text-align: center;
		letter-spacing: 4px;
		margin-bottom: 2.5rem;
		text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
	}

	/* Labels del formulario */
	:deep(.el-form-item__label) {
		color: #e2e8f0 !important;
		font-weight: 500;
		font-size: 0.9rem;
		margin-bottom: 0.5rem;
	}

	/* Inputs estilo oscuro */
	.input-dark :deep(.el-input__wrapper) {
		background: rgba(0, 0, 0, 0.2) !important;
		border: 1px solid rgba(255, 255, 255, 0.1) !important;
		box-shadow: none !important;
		border-radius: 12px;
		height: 50px;
		transition: all 0.3s ease;
	}

	.input-dark :deep(.el-input__wrapper:hover),
	.input-dark :deep(.el-input__wrapper.is-focus) {
		background: rgba(0, 0, 0, 0.3) !important;
		border-color: #3b82f6 !important;
	}

	.input-dark :deep(.el-input__inner) {
		color: white !important;
		font-size: 1rem;
		height: 100%;
	}

	.input-dark :deep(.el-input__inner::placeholder) {
		color: rgba(255, 255, 255, 0.4);
	}

	/* Iconos de los inputs */
	.input-dark :deep(.el-input__prefix-inner) {
		color: rgba(255, 255, 255, 0.6);
		font-size: 1.2rem;
	}

	/* Botón Login */
	.btn-primary {
		background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
		border: none;
		font-weight: 600;
		font-size: 1rem;
		letter-spacing: 0.5px;
		height: 50px;
		margin-top: 1.5rem;
		transition: transform 0.2s, box-shadow 0.2s;
		box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4);
	}

	.btn-primary:hover {
		background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
		transform: translateY(-1px);
		box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
	}

	.btn-primary:active {
		transform: translateY(0);
	}

	.full-width-btn {
		width: 100%;
		border-radius: 12px;
	}
</style>
